export type {
  VisualPromptRepository,
  VisualPromptListFilters,
} from './types';
export { mockVisualPromptRepository } from './mockVisualPromptRepository';
export { combinedVisualPromptRepository } from './combinedVisualPromptRepository';
export { askPromptVisualPromptRepository } from './askPromptVisualPromptRepository';

import { combinedVisualPromptRepository } from './combinedVisualPromptRepository';
import type { VisualPromptRepository } from './types';

/** Active repository — merges custom (localStorage) + mock; swap when API is ready. */
export const visualPromptRepository: VisualPromptRepository =
  combinedVisualPromptRepository;
